import React, { useContext } from 'react'
import { secretStorage } from 'config'
import { DashboardContext } from '../DashboardContext'
import SemesterProgressCard from './SemesterProgressCard'
import StatCard from './StatCard'
import useTopCards from './useTopCards'
import { DashboardTopSectionStyles } from './Style'

// דשבורד חדש משימה z8rp3f97mn
const DashboardTopSection = () => {
    const { dashboardData } = useContext(DashboardContext)
    const cards = useTopCards()
    const user = secretStorage.getUser()

    return (
        <DashboardTopSectionStyles>
            <div className='top-header'>
                <div className='top-header-texts'>
                    <div className='top-title'>{`בוקר טוב, ${user?.first_name || ""}!`}</div>
                    <div className='top-subtitle'>
                        {"תמונת מצב להיום, עבור "}
                        {/* תלמידי השנה הנוכחית (גם בלי סוללה)  total_test_takers_count    */}
                        <b>{dashboardData.semester_summary?.semester_test_takers ?? 0}</b>
                        {" התלמידים שלך:"}
                    </div>
                </div>
                {/* todo- לאפשר אחרי פיתוח העמוד של הדרכות*/}
                <button className='pill-btn main' disabled>
                    {"הדרכות וכללים"}
                    <i className="fa-regular fa-arrow-left-long" />
                </button>
            </div>

            <div className='top-cards'>
                <SemesterProgressCard />

                {cards.map(({ id, rows, ...card }) =>
                    <StatCard key={id} {...card}>
                        {/* מציגים רק שורות שיש בהן מה לטפל */}
                        {rows?.filter(row => row.count > 0).map((row, idx) =>
                            <div className='attention-row' key={idx}>
                                <span className='attention-text'>
                                    {row.info && <i className="fa-regular fa-circle-exclamation" />}
                                    <span><b>{row.count}</b>{` ${row.text}`}</span>
                                </span>
                                <button className='pill-btn' onClick={row.button.action}>{row.button.label}</button>
                            </div>
                        )}
                    </StatCard>
                )}
            </div>
        </DashboardTopSectionStyles>
    )
}

export default DashboardTopSection
